import { showNotification } from "@mantine/notifications";

export const error = ({ title = "Error!", message = "" }) => {
  showNotification({
    color: "red",
    withCloseButton: true,
    autoClose: 3000,
    title: title,
    message: message ?? null,
    loading: false,
  });
};
